<template>
  <div class="k3-demo"> demo </div>
</template>

<script>
  export default {
    name: 'k3-demo'
  }
</script>